// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2nq1-","header":"ReportDetails_header__Vnl6g","title":"ReportDetails_title__39Sne","left":"ReportDetails_left__2jc2a"};